import { render } from "./GroupChatWindow.vue?vue&type=template&id=4f179637"
import script from "./GroupChatWindow.vue?vue&type=script&lang=js"
export * from "./GroupChatWindow.vue?vue&type=script&lang=js"
script.render = render

export default script